import { languageType } from './languageType';

export const translate = async data => {
  if (!data.content) return null;
  const modifiedData = data.content.split('|');
  const finalData = languageType() === 'fr' ? modifiedData[0] : modifiedData[1];
  const returnData = { content: finalData || data.content, fieldType: data.fieldType };
  return returnData;
};
